var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from 'axios';
import { useEffect, useState } from 'react';
import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { useAppName, useLanguage, usePageState, useSitecoreApiHost, useSitecoreApiKey } from '../utils/sitecoreContext';
var useSitecoreLayoutService = function (itemPath) {
    var _a, _b;
    var _c = useState(false), isFetching = _c[0], setIsFetching = _c[1];
    var _d = useState(null), response = _d[0], setResponse = _d[1];
    var _e = useState(), placeholderName = _e[0], setPlaceholderName = _e[1];
    var _f = useState(false), hasError = _f[0], setHasError = _f[1];
    var appName = useAppName();
    var language = useLanguage();
    var sitecoreApiHost = useSitecoreApiHost();
    var sitecoreApiKey = useSitecoreApiKey();
    var context = useSitecoreContext();
    var pageState = usePageState();
    var layoutServiceRoute = context.sitecoreContext.layoutServiceRoute;
    var scModeParam = pageState === 'preview' || pageState === 'edit' ? '&sc_mode=preview' : '';
    var url = "".concat(sitecoreApiHost).concat(layoutServiceRoute, "?item=").concat(itemPath, "&sc_lang=").concat(language, "&sc_apikey=").concat(sitecoreApiKey, "&sc_site=").concat(appName).concat(scModeParam);
    useEffect(function () {
        if (!itemPath) {
            return;
        }
        setIsFetching(true);
        var fetchLayoutServiceItem = function () { return __awaiter(void 0, void 0, void 0, function () {
            var layoutServiceResponse, data, placeholderKeys, err_1;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, axios(url)];
                    case 1:
                        layoutServiceResponse = _c.sent();
                        if (layoutServiceResponse === null || layoutServiceResponse === void 0 ? void 0 : layoutServiceResponse.data) {
                            data = layoutServiceResponse.data;
                            setResponse(data);
                            placeholderKeys = Object.keys((_b = (_a = data.sitecore) === null || _a === void 0 ? void 0 : _a.route) === null || _b === void 0 ? void 0 : _b.placeholders);
                            // By convention, the layout service routes we consume client-site have only one placeholder
                            setPlaceholderName(placeholderKeys[0]);
                        }
                        else {
                            setHasError(true);
                        }
                        setIsFetching(false);
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _c.sent();
                        setHasError(true);
                        setIsFetching(false);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        fetchLayoutServiceItem();
    }, [itemPath, url]);
    var pageMetaData = (_b = (_a = response === null || response === void 0 ? void 0 : response.sitecore) === null || _a === void 0 ? void 0 : _a.context) === null || _b === void 0 ? void 0 : _b.pageMetaData;
    return {
        response: response,
        placeholderName: placeholderName,
        pageMetaData: pageMetaData,
        isFetching: isFetching,
        hasError: hasError,
    };
};
export default useSitecoreLayoutService;
